module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[91]90.d6f03fe.woff2";